module.exports = __webpack_public_path__ + "static/media/semi-truck-lot.bbf1bbd2.jpg";